<template>
  <section
    class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white t-mb-5"
  >
    <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
      <h3 class="t-text-xl t-font-bold">
        Carrier Map
        <span class="t-float-right">
          <label class="t-text-gray-500">
            <input
              v-model="showTrucks"
              class="t-ml-2"
              type="checkbox"
              id="show-trucks"
              value="on"
            />
            <span class="t-text-sm t-text-black">
              Show trucks
            </span>
          </label>
          <label class="t-text-gray-500">
            <input
              v-model="showBookings"
              class="t-ml-2"
              type="checkbox"
              id="show-bookings"
              value="on"
            />
            <span class="t-text-sm t-text-black">
              Show bookings
            </span>
          </label>
          <label class="t-text-gray-500 t-mx-2">
            <i v-if="loading" class="fas fa-spinner fa-spin"></i>
          </label>
        </span>
      </h3>
    </div>
    <Gmap-Map
      style="width: 100%; height: 600px;"
      map-type-id="roadmap"
      ref="map"
      :zoom="6"
      :center="{ lat: -41.543, lng: 174.0277 }"
    >
      <Gmap-Cluster v-if="showBookings">
        <Gmap-Marker
          v-for="booking in bookings"
          :key="booking.id + 'pickupMarker'"
          :position="{
            lat: Number(booking.pickupLocation.data.address.data.latitude),
            lng: Number(booking.pickupLocation.data.address.data.longitude)
          }"
          icon="/images/GmapMarkers/green_MarkerA.png"
        >
        </Gmap-Marker>
        <Gmap-Marker
          v-for="booking in bookings"
          :key="booking.id + 'deliveryMarker'"
          :position="{
            lat: Number(booking.deliveryLocation.data.address.data.latitude),
            lng: Number(booking.deliveryLocation.data.address.data.longitude)
          }"
          icon="/images/GmapMarkers/blue_MarkerB.png"
        >
        </Gmap-Marker>
        <Gmap-Polyline
          v-for="booking in bookings"
          :key="booking.id + 'line'"
          :path="[
            {
              lat: Number(booking.pickupLocation.data.address.data.latitude),
              lng: Number(booking.pickupLocation.data.address.data.longitude)
            },
            {
              lat: Number(booking.deliveryLocation.data.address.data.latitude),
              lng: Number(booking.deliveryLocation.data.address.data.longitude)
            }
          ]"
        >
        </Gmap-Polyline>
      </Gmap-Cluster>
      <Gmap-Marker
        v-for="truck in trucks"
        v-if="showTrucks && truck.currentLocation"
        :key="truck.id"
        :position="{
          lat: Number(truck.currentLocation.data.lat),
          lng: Number(truck.currentLocation.data.lng)
        }"
        :icon="{
          path:
            truck.stopped ||
            (truck.currentLocation && !truck.currentLocation.data.status)
              ? 0
              : 2,
          scale:
            truck.stopped ||
            (truck.currentLocation && !truck.currentLocation.data.status)
              ? 5
              : 3,
          rotation: Number(truck.currentLocation.data.course_over_ground)
        }"
        @click="infoWindow = truck"
      >
      </Gmap-Marker>
      <Gmap-Info-Window
        v-if="infoWindow !== null"
        :opened="infoWindow !== null"
        :position="{
          lat: infoWindow.currentLocation.data.lat,
          lng: infoWindow.currentLocation.data.lng
        }"
        @closeclick="infoWindow = null"
      >
        <b>Truck: </b>{{ infoWindow.plate }}({{ infoWindow.display_name }})
        <br /><b>Status: </b>Ignition
        {{ infoWindow.currentLocation.data.status ? "On" : "Off" }},
        {{ infoWindow.currentLocation.data.speed }}km/h,
        {{ moment(infoWindow.currentLocation.data.time).fromNow() }} ({{
          moment(infoWindow.currentLocation.data.time).format(
            "h:mm:ss a, ddd Do MMM 'YY"
          )
        }}) <br /><b>Location: </b
        >{{ infoWindow.currentLocation.data.location }} <br /><b>Weights: </b
        >Tare {{ infoWindow.tare_weight }}kg, GVM
        {{ infoWindow.gross_vehicle_weight }}kg
        <hr />
        <button
          @click="
            showRoute(
              infoWindow,
              moment()
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss'),
              moment()
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss')
            )
          "
          class="btn btn-sm btn-primary"
        >
          Show route today
        </button>
        <button
          @click="
            showRoute(
              infoWindow,
              moment()
                .subtract(1, 'days')
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss'),
              moment()
                .subtract(1, 'days')
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss')
            )
          "
          class="btn btn-sm btn-primary"
        >
          Show route yesterday
        </button>
      </Gmap-Info-Window>
      <Gmap-Marker
        v-for="point in route"
        v-if="route"
        :key="point.id"
        :position="{
          lat: Number(point.lat),
          lng: Number(point.lng)
        }"
        :icon="{
          path: 0,
          scale: 5,
          rotation: Number(point.course_over_ground)
        }"
        @click="
          infoWindowPoint = point;
          infoWindow = null;
        "
      >
      </Gmap-Marker>
      <Gmap-Info-Window
        v-if="infoWindowPoint !== null"
        :opened="infoWindowPoint !== null"
        :position="{ lat: infoWindowPoint.lat, lng: infoWindowPoint.lng }"
        @closeclick="infoWindowPoint = null"
      >
        <strong>Stopped at: </strong
        >{{ infoWindowPoint.startPoint.data.location }} <br /><strong
          >For: </strong
        >{{ infoWindowPoint.duration }} minutes
        {{ moment(infoWindowPoint.time).fromNow() }} ({{
          moment(infoWindowPoint.time).format("h:mm:ss a, ddd Do MMM 'YY")
        }})
        <hr />
        <button @click="closeRoute()" class="btn btn-sm btn-primary">
          Close route
        </button>
      </Gmap-Info-Window>
    </Gmap-Map>
  </section>
</template>

<script>
import LoadingAlert from "../../../components/utils/LoadingAlert";
import moment from "moment";
import { loaded } from "vue2-google-maps";

export default {
  name: "truck-map",
  components: {
    LoadingAlert
  },

  data() {
    return {
      loadingBookings: true,
      loadingTrucks: true,
      loadingRoute: false,

      bookings: null,
      trucks: null,
      route: null,

      infoWindow: null,
      infoWindowPoint: null,
      showBookings: true,
      showTrucks: true,
      directionsDisplay: null
    };
  },

  mounted() {
    loaded.then(() => {
      this.loadBookings();
      this.loadTrucks();
    });
  },

  methods: {
    moment(val = null) {
      if (val) {
        return moment(val);
      }

      return moment();
    },

    loadBookings() {
      axios
        .get(
          "/carry-freight/bookings/current?include=pickupLocation.address,deliveryLocation.address",
          { Accept: "application/json" }
        )
        .then(response => {
          this.bookings = response.data.data;
          this.loadingBookings = false;
        });
    },

    loadTrucks() {
      api
        .get("/carrier/gps/trucks", {
          params: {
            include: "currentLocation"
          }
        })
        .then(response => {
          this.trucks = response.data.data;
          this.loadingTrucks = false;
        });
    },

    showRoute(truck, startTime, endTime) {
      this.infoWindow = null;
      this.showTrucks = false;
      this.showBookings = false;
      this.loadingRoute = true;

      this.loadRoute(truck, startTime, endTime);
    },

    closeRoute() {
      this.route = [];
      this.infoWindowPoint = null;
      this.showTrucks = true;
      this.directionsDisplay.setMap(null);
    },

    loadRoute(truck, startTime, endTime) {
      api
        .get(
          "/carrier/gps/stops?truck_id=" +
            truck.id +
            "&start_time=" +
            startTime +
            "&end_time=" +
            endTime +
            "&include=startPoint&sort=asc&previous=included"
        )
        .then(response => {
          this.route = response.data.data;
          //init googlemap
          let directionsService = new google.maps.DirectionsService();
          this.directionsDisplay = new google.maps.DirectionsRenderer({
            map: this.$refs.map.$mapObject
          });
          let directionsDisplay = this.directionsDisplay;
          //prepare points for routes: max number is 23 + origin and destination = 25
          const chunk = 23;
          const pointInterval = Math.ceil(this.route.length / chunk);
          let wayPoints = [];
          for (
            let index = 1;
            index < this.route.length;
            index += pointInterval
          ) {
            wayPoints.push({
              location: {
                lat: this.route[index].lat,
                lng: this.route[index].lng
              },
              stopover: true
            });
          }
          //draw routes
          directionsService.route(
            {
              origin: {
                lat: this.route[0].lat,
                lng: this.route[0].lng
              },
              destination: {
                lat: truck.currentLocation.data.lat,
                lng: truck.currentLocation.data.lng
              }, //use current location as destination
              waypoints: wayPoints,
              avoidTolls: false,
              avoidHighways: false,
              travelMode: google.maps.TravelMode.DRIVING
            },
            function(response, status) {
              if (status === google.maps.DirectionsStatus.OK) {
                directionsDisplay.setDirections(response);
              } else {
              }
            }
          );
          //close the routes if only one point
          if (response.data.data.length < 1) {
            this.$Message.error({
              content: "No GPS data in this period",
              duration: 10,
              closable: true
            });
            this.closeRoute();
          }
        })
        .catch(error => {
          console.log(error);
          this.$Message.error({
            content: "Failed to load GPS data",
            duration: 10,
            closable: true
          });
        })
        .then(() => {
          this.loadingRoute = false;
        });
    }
  },

  computed: {
    loading() {
      return this.loadingBookings || this.loadingTrucks || this.loadingRoute;
    }
  },

  watch: {
    trucks(trucks) {
      if (trucks.length > 2) {
        const bounds = new google.maps.LatLngBounds();
        for (let m of trucks) {
          if (m.currentLocation) {
            bounds.extend({
              lat: Number(m.currentLocation.data.lat),
              lng: Number(m.currentLocation.data.lng)
            });
          }
        }
        this.$refs.map.fitBounds(bounds);
      }
    }
  }
};
</script>
